module.exports = __webpack_public_path__ + "h5/img/cs_18.cb43c8f4.jpeg";